import { EventHandlerFactory } from '../sse-resource';

/**
 * Helper function for defining the data type of the Server Sent Event
 */
export function sse<T>(): EventHandlerFactory<T> {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  return (() => (_: T) => {}) as EventHandlerFactory<T>;
}
